/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { ROUTES } from '@sportninja/common/constants/app'
import { NO_COMPETITIONS_GUIDANCE } from '@sportninja/common/features/profile/finderSettings/guidance'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { font, paragraphXSmall } from 'src/components/css'
import Button from 'src/components/ts-components/Button'

/**
 * A preference card's Competitions section when it is saved for none: says so,
 * and opens Team Finder in a new tab (the profile stays where it was) to join
 * a team.
 */
const FinderNoCompetitions: React.FC = () => (
  <div css={containerStyle}>
    <div css={bodyStyle}>{NO_COMPETITIONS_GUIDANCE.body}</div>
    <div css={actionStyle}>
      <Button
        text={capitalizeWords(NO_COMPETITIONS_GUIDANCE.action)}
        variant='secondary'
        onClick={() =>
          window.open(ROUTES.TEAM_FINDER, '_blank', 'noopener,noreferrer')
        }
      />
    </div>
  </div>
)

export default FinderNoCompetitions

// ─── Styles ────────────────────────────────────────────────────────────────

/* `align-items: flex-start` keeps the action wrapper at its content width. */
const containerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

const bodyStyle = css`
  ${font.body}
  ${paragraphXSmall}
  color: ${colors.NEUTRAL_50};
`

// The CTA hugs its label instead of stretching (the shared Button is flex: 1).
const actionStyle = css`
  display: flex;
`
